import { render, staticRenderFns } from "./authCode.vue?vue&type=template&id=8335d4fe&"
import script from "./authCode.vue?vue&type=script&lang=js&"
export * from "./authCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports